import { createClient } from "@supabase/supabase-js";

// Supabase configuration from environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Validate that required environment variables are present
if (!supabaseUrl) {
  throw new Error("Missing VITE_SUPABASE_URL environment variable");
}

if (!supabaseAnonKey) {
  throw new Error("Missing VITE_SUPABASE_ANON_KEY environment variable");
}

// Create the Supabase client for browser usage
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Use localStorage for session persistence
    storage: typeof window !== "undefined" ? window.localStorage : undefined,
    // Automatically refresh the token before it expires
    autoRefreshToken: true,
    // Persist the session across browser tabs
    persistSession: true,
    // Detect session from URL (for OAuth redirects)
    detectSessionInUrl: true,
    // Use PKCE so the ?code= exchange can surface errors instead of failing silently
    flowType: "pkce",
  },
});

// Export the URL for direct function calls
export { supabaseUrl };

// Export types for use in the app
export type SupabaseClient = typeof supabase;
